import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import userAuth from '../../Config/userauth';
import MainLayout from '../MainLayout';

/**
 * Componente para proteger rutas que requieren autenticación
 */
export const ProtectedRoute = ({ 
  children, 
  requireAdmin = false,
  requirePasswordChange = false,
  requireProducerSelection = false,
  allowedRoutes = []
}) => {
  const location = useLocation();
  const isAuth = userAuth.isAuthenticated();

  // Si no está autenticado, redirigir al login
  if (!isAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si requiere ser admin y no lo es
  if (requireAdmin && !userAuth.isAdmin()) {
    return <Navigate to="/home" replace />;
  }

  // Si requiere cambio de contraseña
  if (requirePasswordChange && userAuth.requestChangePassword()) {
    const resetUrl = `/recover-reset?code=${userAuth.userCode()}&simulador=true`;
    return <Navigate to={resetUrl} replace />;
  }

  // Si requiere selección de productor
  if (requireProducerSelection && userAuth.requestSelectProducer()) {
    return <Navigate to="/simulate-producer" replace />;
  }

  // Filtrar rutas permitidas si se especifica una lista
  if (allowedRoutes.length > 0) {
    const isAllowed = allowedRoutes.some(route => {
      if (typeof route === 'string') {
        return location.pathname.startsWith(route);
      }
      return route.test(location.pathname);
    });
    
    if (!isAllowed) {
      return <Navigate to="/home" replace />;
    }
  }

  // Si pasa todas las validaciones, renderizar con el layout principal
  return <MainLayout>{children}</MainLayout>;
};

/**
 * Componente para rutas públicas (no requieren autenticación)
 */
export const PublicRoute = ({ children }) => {
  const location = useLocation();
  const isAuth = userAuth.isAuthenticated();

  // Si está autenticado y trata de acceder a login, redirigir a home
  if (isAuth && location.pathname === '/login') {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};
